<template>
	<div class="input-label flex-space-between--center">
		<div class="text-left">
			<div class="param-title flex-start--center">
				<div>
					<span v-if="!hasMapper || !mapperMapping">{{ param.name }}</span>
					<span v-else
						>{{ mapperMapping.displayName }} <span class="mapped-title"> [Mapped to "{{ param.name }}"]</span>
					</span>
					<span v-if="isItemType"> »</span>
				</div>
				<DataTypeIcon class="data-type-icon ml-2" :class="{ 'is-focused': isFocused }" :typeName="typeFormat" :size="14" />
			</div>
			<div v-if="showParamMetadata && param.description" class="param-description">{{ param.description }}</div>
		</div>
		<div class="text-right">
			<RequiredChip v-if="isRequired" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import IsRequiredMixin from '../mixins/ParamPropertiesMixins/IsRequiredMixin';
import IsItemTypeParamMixin from '../mixins/ParamPropertiesMixins/IsItemTypeParamMixin';
import RequiredChip from '../../Chips/RequiredChip';
import ParamTypesService from '../ParamTypesService';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';
export default {
	name: 'ParamTitle',
	props: {
		showParamMetadata: { type: Boolean, default: false },
		isFocused: { type: Boolean },
		node: { type: Object },
	},
	mixins: [IsRequiredMixin, IsItemTypeParamMixin],
	components: { RequiredChip },
	computed: {
		...mapGetters([getWidgetFieldData.fullPath]),
		typeFormat() {
			return ParamTypesService.getTypeFormat(this.param.type, this.param.format);
		},
		hasMapper() {
			return this.node.user_schema_mappings_source_field_uuid;
		},
		mapperMapping() {
			return (
				this[getWidgetFieldData.fullPath](this.node.user_schema_mappings_source_field_uuid)?.widgetField?.metadata?.source?.mappings || []
			).find((map) => map.originalKey === this.param.key);
		},
	},
};
</script>

<style scoped lang="scss">
.param-title {
	font-size: 14px;
	font-weight: 500;
	.mapped-title {
		font-size: 11px;
		font-weight: 200;
	}
}
.param-description {
	font-size: 12px;
	font-weight: normal;
}
.data-type-icon {
	opacity: 0.1;
	transition: 0.3s;

	&.is-focused {
		opacity: 1;
		transition: 0.2s;
	}
}
</style>
